import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    workTypeName?: ?string;
}

export class TimesheetEntryWorkTypeName extends React.PureComponent<Props> {
    render() {
        const { workTypeName } = this.props;
        if (!workTypeName) return null;
        return workTypeName;
    }
}

const mapStateToProps = createStructuredSelector({
    workTypeName: makeSelectTimesheetEntryValue('workTypeName')
});

export default connect(mapStateToProps)(TimesheetEntryWorkTypeName);
